import axios from 'axios'

const FeedbackService = {
  async getList (params = {}) {
    return axios.get('admin/feedback', { params })
  },

  async show (id) {
    return axios.get(`admin/feedback/${id}`)
  }
}

export default FeedbackService
